import { render, staticRenderFns } from "./LentiSole.vue?vue&type=template&id=e0b1c234&scoped=true"
import script from "./LentiSole.vue?vue&type=script&lang=ts"
export * from "./LentiSole.vue?vue&type=script&lang=ts"
import style0 from "./LentiSole.vue?vue&type=style&index=0&id=e0b1c234&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b1c234",
  null
  
)

export default component.exports